import React from "react";

export default function CardGallery() {
  return (
    <div className="w-5/6 mx-auto lg:mx-0 lg:grid lg:grid-cols-3 lg:px-10 lg:gap-5 2xl:px-20 2xl:gap-10 mt-8 space-y-5 lg:space-y-0">
      <img
        className="2xl:w-80 shadow-lg rounded-lg"
        src="assets/lantai1.png"
        alt=""
      />
      <img
        className="2xl:w-80 shadow-lg rounded-lg"
        src="assets/lantai2.png"
        alt=""
      />
      <img
        className="2xl:w-80 shadow-lg rounded-lg"
        src="assets/lantai3.png"
        alt=""
      />

      <img
        className="2xl:w-80 shadow-lg rounded-lg"
        src="assets/parkir.png"
        alt=""
      />
      <img
        className="2xl:w-80 shadow-lg rounded-lg"
        src="assets/ruanggigi.jpg"
        alt=""
      />
      <img
        className="2xl:w-80 shadow-lg rounded-lg"
        src="assets/labor.jpg"
        alt=""
      />
    </div>
  );
}
